
import { GetJoinGroupList, reload, useChatStore } from "../../../store/ChatStore";
import { GroupMember } from "../../../../imsdk/db/t_group_member";
import { joinGroupDeal } from "../../../net/service";
import { showToast } from "../../../components/Toast";
import { FlatList, Text, View } from "react-native";
import { ButtonView } from "../../../components/ButtonView";
import { Str_Agree, Str_GroupApplication, Str_OperationFailed, Str_OperationSuc, Str_Refuse } from "../../../language/string_res";
import { User } from "../../../../imsdk/db/t_user";
import { color_333333, color_999999, color_main, ColorLine, ColorRed, white } from "../../../assets/style/colors";
import { getUserName } from "../chat-helper";
import { LeftView } from "../CListItem";
import { ListEmpty } from "../../../components/ListEmpty";
import { MainNavProps } from "../../navigation/main/MainParamList";
import { getAvatarByUser } from "../../../utils/utils";
import { ScreenCloseModal } from "../../../components/ScreenModal";


export const JoinGroupScreen = ({ navigation, route }: MainNavProps<"JoinGroupScreen">) => {
    const { chatState, chatDispatch } = useChatStore()
    if (!chatState) return
    const users = chatState.joinGroupUsers?.users;
    const groupRequests = chatState.joinGroupUsers?.groupRequests
    const tid = chatState.curTopicWithSummary?.topic?.tid;

    function handleSubmit(user: User | GroupMember, op: number) {
        joinGroupDeal({ tid: tid, applyUid: user.uid, op: op }).then((res) => {
            if (res.code === 0) {
                showToast(Str_OperationSuc)
                GetJoinGroupList(chatState, chatDispatch)
                reload(tid, chatDispatch)
                navigation.goBack()
            } else {
                showToast(Str_OperationFailed)
            }
        })
    }


    function rightRender(item: User | GroupMember) {
        return (<View style={{ flexDirection: 'row' }}>
            <ButtonView
                textStyle={{ color: white, fontSize: 14 }}
                text={Str_Agree}
                onPress={() => handleSubmit(item, 1)}
                style={{
                    backgroundColor: color_main,
                    paddingHorizontal: 10,
                    paddingVertical: 4,
                    borderRadius: 4
                }} />
            <ButtonView
                textStyle={{ color: white, fontSize: 14 }}
                text={Str_Refuse}
                onPress={() => handleSubmit(item, 2)}
                style={{
                    marginStart: 20,
                    backgroundColor: ColorRed,
                    paddingHorizontal: 10,
                    paddingVertical: 4,
                    borderRadius: 4
                }} />
        </View>)
    }
    const Item = ({ item }: { item: User | GroupMember }) => {
        const filter = groupRequests?.filter((data) => data.applyUid === item.uid)

        return (<View style={{
            flexDirection: 'row',
            alignItems: 'center',
            paddingHorizontal: 16,
            width: '100%',
            paddingVertical: 12
        }}>
            <LeftView left={getAvatarByUser(item)} size={50} />
            <View style={{
                flexDirection: 'column',
                alignItems: 'flex-start',
                flex: 1,
                marginEnd: 10,
                justifyContent: 'flex-start',
            }}>
                <Text style={{
                    fontSize: 16,
                    color: color_333333
                }}>{getUserName(item)}</Text>


                {filter && filter.length > 0 && filter[0].hello &&
                    <Text
                        numberOfLines={1}
                        ellipsizeMode={"tail"}
                        style={{
                            fontSize: 12,
                            color: color_999999,
                            flex: 1,
                            marginTop: 2,
                        }}>{filter[0].hello}</Text>}
            </View>

            {rightRender(item)}
            <View style={{
                backgroundColor: ColorLine,
                height: 0.5,
                position: 'absolute',
                bottom: 0,
                start: 16, end: 16,
            }} />
        </View>)
    }
    return (
        <ScreenCloseModal title={Str_GroupApplication}>
            <FlatList
                ListEmptyComponent={<ListEmpty />}
                data={users}
                style={{ marginTop: 1, backgroundColor: white }}
                renderItem={Item} />
        </ScreenCloseModal>
    );
};
